/**
 * RESPONSIBILITY: the /adc page's closing words and links.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';

@Section({ name: SectionName.AdcFoot, label: 'Austin Desi Christmas - Footer' })
export class AdcFootSection {
  @Text({ label: 'Line', maxLength: 300, default: 'Jesus is the Reason for the Season' })
  line!: string;

  @Paragraph({ label: 'Verse', maxLength: 600, rows: 2, default: 'May the God of hope fill you with all joy and peace as you trust in Him. Romans 15:13' })
  verse!: string;

  @Text({ label: 'Contact', maxLength: 300, default: 'info@acfi.cc' })
  contact!: string;

  @Link({ label: 'Link to ACFI', default: 'https://acfi.cc' })
  siteHref!: string;

  @Text({ label: 'Link text', maxLength: 120, default: 'acfi.cc' })
  siteLabel!: string;

  @Text({ label: 'Small print', maxLength: 300, default: 'Austin Christian Fellowship of India' })
  smallPrint!: string;
}
